import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocalStorageService } from 'app/shared';

@Component({
  selector: 'app-form-accept',
  templateUrl: './app-form-accept.component.html',
})
export class AppFormAcceptComponent implements OnInit {

  form: FormGroup;
  items: FormArray;

  constructor(
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
  ) {}

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit (): void {
    this.form = new FormGroup({
      app_form_accept: new FormControl(),
    });

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });
  }

  createItem(): FormGroup {
    const savedData = this.localStorageService.load('app_form_accept');
    return this.formBuilder.group({
      app_form_accept: savedData || '',
    });
  }

  onChangeAccept(): void {
    this.localStorageService.save('app_form_accept', this.formData.value[0].app_form_accept);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-accept/app-form-accept.component.ts